import Vue from 'vue'
import App from './App.vue'
import _ from 'lodash'
import router from './router'
import store from './store'
import "@/styles/index.css"
import "@/styles/icon/iconfont.css"


//引入element
import ElementUI from 'element-ui';
import { Message, Loading } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Editor from '@tinymce/tinymce-vue'
import numeral from 'numeral';


//引入Fastboot UI库
import FastbootUI from 'fastboot-ui-ankh/src/components';
import 'fastboot-ui-ankh/src/scss/element-theme.scss'

Vue.use(FastbootUI);


// 引入vex
import VxeUITable from 'vxe-table'
import 'vxe-table/lib/style.css'
Vue.use(VxeUITable)

import i18n from "@/config/i18n"
Vue.use(ElementUI, {
  i18n: (key, value) => {
    return i18n.t(key, value)
  }
})

import FastbootAdmin from 'fastboot-admin-ankh';
Vue.component('editor', Editor);


//引入全局工具和配置
import qs from 'qs'
import axios from 'axios'

//引入接口
import baseApi from './config/api'
let api = _.defaultsDeep(baseApi, FastbootAdmin.api);
router.addRoutes(FastbootAdmin.routes)

import moment from 'moment'
import {CustomLoading} from "@/utils/loading";
const loading = new CustomLoading(Loading);

Vue.prototype.$moment = moment;
Vue.prototype.$api = api;
Vue.prototype.$http = axios;
Vue.prototype.$qs = qs;
Vue.prototype.$customLoading = loading;
axios.defaults.withCredentials = true;

Vue.config.productionTip = false


import filters from "./utils/filters"

Object.keys(filters).map(v => {
  Vue.filter(v, filters[v]);
});


Vue.filter('numeral', function (value) {
  try {
    if (!value) {
      return '(空)'
    }
    return numeral(parseFloat(value).toFixed(2)).format('0,0.00');
  } catch (e) {
    return '(空)'
  }
})

//http响应拦截器
Vue.prototype.$http.interceptors.response.use(resp => {

  //如果未授权，则跳转至授权页面
  if (resp.data.status === 401) {

    if (sessionStorage.getItem("login-user-info") != null) {
      // Message.warning("30分钟未操作自动退出登录");
    }

    sessionStorage.removeItem("login-user-info");




    router.push("/login");


  }

  //如果未授权，则跳转至授权页面
  if (resp.data.status === 403 && resp.data.desc !== "用户名或密码错误") {
    router.push("/no-permission");
  }

  return resp;

}, error => {
  return Promise.reject(error)
});






//加载系统信息
axios.post(api.app.appInfo).then((resp) => {

  window.appInfo = resp.data.data.appInfo;
  try {
    window.appSetting = JSON.parse(resp.data.data.appInfo.setting);
  } catch (e) {
    window.appSetting = {};
  }

  if (!window.appSetting) {
    window.appSetting = {};
  }

  if (window.appInfo.logo) {
    window.appInfo.logoUrl = `${api.commonFile.download}?code=${window.appInfo.logo}`;
  }


  if (window.appInfo.name) {
    document.title = window.appInfo.name;
  } else {
    document.title = "未配置系统名称";
  }


  //路由拦截器
  router.beforeEach((to, form, next) => {

    loading.hideLoading();

    if (to.path.startsWith('/update-user-password')) {
      next();
      if (window.updatePassword) {
        Message.warning("请修改密码再进行操作！");
      }
      return;
    }


    if (sessionStorage.getItem("login-user-info") != null) {

      let userInfo = JSON.parse(sessionStorage.getItem("login-user-info"));

      if (window.appSetting["UPDATE_PWD_INTERVAL"] && window.appSetting["UPDATE_PWD_INTERVAL"].value !== "0") {

        if (!userInfo.lastUpdatePwdTime) {
          window.updatePassword = true;

          next('/update-user-password')
          return;
        }

        if (userInfo.lastUpdatePwdTime <= parseInt(window.appSetting["UPDATE_PWD_INTERVAL"]) * 24 * 60 * 60 * 1000) {
          next('/update-user-password');
          return;
        }

        next();

      } else {
        next();
      }

    } else {
      next();
    }

  });

  // 设置系统跳转页面模式
  window.routeViewType = 'route';

  new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
  }).$mount('#app');

});

